/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each axis is scaled to the maximum value for that metric, so every dimension is fully visible regardless of the units involved.`)
};

const es_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada eje se escala al valor máximo de esa métrica, así que todas las dimensiones son totalmente visibles sin importar las unidades involucradas.`)
};

const de_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Achse wird auf den Maximalwert für diese Kennzahl skaliert, sodass jede Dimension unabhängig von den beteiligten Einheiten vollständig sichtbar ist.`)
};

const nl_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke as wordt geschaald naar de maximumwaarde voor die metric, zodat elke dimensie volledig zichtbaar is, ongeacht de betrokken eenheden.`)
};

const fr_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque axe est mis à l'échelle selon la valeur maximale de cette métrique, afin que chaque dimension soit pleinement visible quelles que soient les unités impliquées.`)
};

const it_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni asse è scalato al valore massimo per quella metrica, così ogni dimensione è completamente visibile indipendentemente dalle unità coinvolte.`)
};

const pt_br2_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada eixo é escalado ao valor máximo daquela métrica, para que cada dimensão fique totalmente visível independentemente das unidades envolvidas.`)
};

const pt_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada eixo é dimensionado até ao valor máximo dessa métrica, para que todas as dimensões fiquem totalmente visíveis independentemente das unidades envolvidas.`)
};

const ja_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各軸はその指標の最大値に合わせてスケールされるため、単位に関わらずすべての次元が完全に見えるようになります。`)
};

const zh_radar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每条轴都按该指标的最大值进行缩放，因此无论涉及什么单位，每个维度都能完全可见。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_faq_a3", locale)
	if (locale === "en") return en_radar_faq_a3(inputs)
	if (locale === "es") return es_radar_faq_a3(inputs)
	if (locale === "de") return de_radar_faq_a3(inputs)
	if (locale === "nl") return nl_radar_faq_a3(inputs)
	if (locale === "fr") return fr_radar_faq_a3(inputs)
	if (locale === "it") return it_radar_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_radar_faq_a3(inputs)
	if (locale === "pt") return pt_radar_faq_a3(inputs)
	if (locale === "ja") return ja_radar_faq_a3(inputs)
	return zh_radar_faq_a3(inputs)
};